import { Stack, StackItem } from '@patternfly/react-core'
import { useContext, useEffect, useMemo, useState } from 'react'
import { toDateTuple } from '../../utils/formatDate'

import SitesContext from '../../contexts/SitesContext'
import PageFrame from '../shared/Page'
import SelectSite from '../shared/selects/SelectSite'
import useData from './useData'

import DatetimeRangePicker from '../../components/calendar/DatetimeRangePicker'
import { categories, CATEGORIES_DEFAULTS } from './constants'
import PanelSite from './PanelSite'
import PanelTurb from './PanelTurb'
import PanelWindFarm from './PanelWindFarm'
import SelectCategories from './SelectCategories'
import { useButtonActiveType } from './useButtonActiveType'

const TimeAvailability = () => {
  const { site, isLoading: sitesIsLoading } = useContext(SitesContext)

  const [revision, setRevision] = useState(1)

  const [categorySelection, setCategorySelection] = useState<categories>(CATEGORIES_DEFAULTS)

  // Var 'month' is "javascript month" (0-11)
  const [year, month, day] = toDateTuple(new Date())

  const defaultEnd =
    new Date(year, month + 1, 0) > new Date(year, month, day - 1)
      ? new Date(year, month, day - 1)
      : new Date(year, month + 1, 0)

  const [dateIn, setDateIn] = useState(new Date(year, 0, 1))
  const [dateFin, setDateFin] = useState(defaultEnd)

  const minDate = new Date(site.commissioning_date)

  const [isNavOpen, setNavOpen] = useState(window.innerHeight < window.innerWidth)
  const { isLoading: isContentLoading } = useData(dateIn, dateFin)

  const handleSelectDate = (newStart: Date, newEnd: Date) => {
    setDateIn(newStart)
    setDateFin(newEnd)
  }

  useEffect(() => {
    setRevision(revision + 1)
  }, [isNavOpen, site, sitesIsLoading])

  const { activeType, ButtonsExibição } = useButtonActiveType()

  return (
    <PageFrame
      pageName='Disponibilidade Temporal'
      siteName={site?.site_name}
      siteId={site?.site_id}
      isNavOpen={isNavOpen}
      setNavOpen={setNavOpen}
      isLoading={sitesIsLoading}
      isContentLoading={isContentLoading}
      filters={[
        <ButtonsExibição key='ButtonsExibição' />,
        <SelectCategories
          categorySelection={categorySelection}
          setCategorySelection={setCategorySelection}
          key='SelectCategories'
        />,
        <SelectSite key='SelectSite' enableUrlParams />,
        <DatetimeRangePicker
          key='DatetimeMonthPicker'
          value={{ startDate: dateIn, endDate: dateFin }}
          maxEnabled={new Date(year, month, day - 2)}
          minEnabled={minDate}
          calendarVariant='date'
          onChange={handleSelectDate}
        />,
      ]}
    >
      <Stack hasGutter>
        <StackItem>
          <PanelSite
            isLoading={sitesIsLoading}
            dateIn={dateIn}
            dateFin={dateFin}
            revision={revision}
            categorySelection={categorySelection}
            activeType={activeType}
          />
        </StackItem>
        <StackItem>
          <PanelWindFarm
            dateIn={dateIn}
            dateFin={dateFin}
            revision={revision}
            categorySelection={categorySelection}
            activeType={activeType}
          />
        </StackItem>
        <StackItem>
          <PanelTurb
            dateIn={dateIn}
            dateFin={dateFin}
            revision={revision}
            categorySelection={categorySelection}
            activeType={activeType}
          />
        </StackItem>
      </Stack>
    </PageFrame>
  )
}

export default TimeAvailability
